import React from "react";

export default function FourOFour() {
  return (
    <div className="vh-100 w-100 text-center d-flex align-items-center justify-content-between px-3">
      <div className="max-w-md-xl mx-auto">
        <h1>404</h1>
        <p className="py-5">
          The page you're looking for is currently unavailable
        </p>
      </div>
    </div>
  );
}
